<template>
  <permission-gate
    v-slot="{ canEdit }"
    moduleKey="cilindros"
  >
    <main-breadcrumb
      :items="items"
      showBackButton
    ></main-breadcrumb>
    <main-buttons-bar :align="'space-between'">
      <template #left>
        <custom-title>Listado de Engrane Troquel</custom-title>
      </template>
      <template #right>
        <el-tooltip
          v-if="!canEdit"
          content="El usuario no posee permisos de edición"
          placement="top"
        >
          <el-button
            type="primary"
            size="default"
            :icon="IconAdd"
            disabled
            >Nuevo Engrane Troquel</el-button
          >
        </el-tooltip>

        <template v-else>
          <el-button
            type="primary"
            size="default"
            :icon="IconAdd"
            @click="openModal"
            >Nuevo Engrane Troquel</el-button
          >
          <modal-new-cylinder-adapter
            v-model="modalVisible"
            @closed="handleModalClosed"
          ></modal-new-cylinder-adapter>
        </template>
      </template>
    </main-buttons-bar>

    <cylinder-adapters-filters></cylinder-adapters-filters>

    <custom-table
      :requestApi="findAllCilindroAdaptadorHTTP"
      :pathEdit="'/page/cylinder-adapters/edit'"
      :pathDetail="'/page/cylinder-adapters/detail'"
      :paramId="'Codigo'"
      :data="cylinderAdapterList"
      :columns="columns"
    >
      <template #custom-actions="{ row }">
        <el-tooltip
          v-if="canEdit"
          content="Eliminar"
          placement="top"
        >
          <el-button
            :icon="IconDelete"
            type="danger"
            @click.prevent="onDelete(row.Codigo)"
          ></el-button>
        </el-tooltip>
      </template>
    </custom-table>
  </permission-gate>
</template>

<script setup>
import {
  ref,
  onBeforeMount,
} from 'vue';
import { ElMessageBox } from 'element-plus';
import { useCylinderAdapterStore } from '../stores/cylinder_adapters_store.js';
import { storeToRefs } from 'pinia';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import CustomTable from '@/shared/components/custom_table.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import CylinderAdaptersFilters from './cylinder_adapters_filters.vue';
import IconAdd from '~icons/mdi/add';
import IconDelete from '~icons/mdi/delete';
import ModalNewCylinderAdapter from './modal_new_cylinder_adapter.vue';
import PermissionGate from '@/shared/components/permission_gate.vue';
import { useMessageError } from '@/shared/composables/message_error.js';
import { useMessageSuccess } from '@/shared/composables/message_success.js';

const cylinderAdapterStore = useCylinderAdapterStore();
const { cylinderAdapterList } = storeToRefs(cylinderAdapterStore);
const {
  firstCilindroAdaptador,
  findAllCilindroAdaptadorHTTP,
  resetFilter,
  deleteCilindroAdaptadorHTTP,
} = cylinderAdapterStore;

const items = [
  { label: 'Inicio', to: '/dashboard', replace: false },
  { label: 'Listado', to: null, replace: false },
];

const columns = [
  { field: 'CilindroTipo', label: 'Cilindro tipo', width: 200, sortable: true, isVisible: true },
  { field: 'Dientes', label: 'Dientes', width: 140, sortable: true, isVisible: true },
  { field: 'Paso', label: 'Paso (mm)', width: 140, sortable: true, isVisible: true },
];

const modalVisible = ref(false);

const openModal = () => {
  modalVisible.value = true;
};

const handleModalClosed = async () => {
  modalVisible.value = false;
  await firstCilindroAdaptador();
};

const onDelete = async (codigo) => {
  try {
    await ElMessageBox.confirm(
      '¿Seguro que desea eliminar el Engrane Troquel seleccionado?',
      'Confirmación',
      {
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        type: 'warning',
      },
    );

    await deleteCilindroAdaptadorHTTP(codigo);
    useMessageSuccess().open('Engrane Troquel eliminado correctamente');
    await firstCilindroAdaptador();
  } catch (error) {
    if (error !== 'cancel') {
      useMessageError().open(
        error.response?.data?.message || 'No se pudo eliminar el Engrane Troquel',
      );
    }
  }
};

onBeforeMount(async () => {
  resetFilter();
  await firstCilindroAdaptador();
});
</script>

<style scoped></style>
